import { render, staticRenderFns } from "./CommunityRightSidebar.vue?vue&type=template&id=b79a7cd8&scoped=true&"
import script from "./CommunityRightSidebar.vue?vue&type=script&lang=js&"
export * from "./CommunityRightSidebar.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b79a7cd8",
  null
  
)

export default component.exports